var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lab_bottomRight"},[_vm._m(0),_c('div',{staticClass:"course_tabInfoText clearfix"},[_c('div',{staticClass:"course_tabInfonew",domProps:{"innerHTML":_vm._s(_vm.labInfo.scoreEvaluate)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lab_bottomTitle"},[_c('img',{staticClass:"lab_titleBack",attrs:{"src":require("@/images/lab_titleBack.png")}}),_c('span',[_vm._v("实验介绍")])])
}]

export { render, staticRenderFns }